import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"



type Props = {
  isLoggedIn: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'NewGameButtonsView',
  props: {
    isLoggedIn: { type: Boolean }
  },
  emits: [
  "randomGamePressed",
  "friendGamePressed",
  "localGamePressed",
],
  setup(__props: any, { emit }) {




return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, { class: "justify-center pa-15 mt-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          onClick: _cache[0] || (_cache[0] = () => emit('randomGamePressed')),
          class: "mr-8 pa-8",
          elevation: "8",
          color: "grey-darken-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Random Opponent "),
            (!__props.isLoggedIn)
              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                  key: 0,
                  activator: "parent",
                  location: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Log in to find opponent ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_card, {
          onClick: _cache[1] || (_cache[1] = () => emit('friendGamePressed')),
          class: "pa-8 pointer",
          elevation: "8",
          color: "grey-darken-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Play a friend "),
            (!__props.isLoggedIn)
              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                  key: 0,
                  activator: "parent",
                  location: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Log in to play with a friend ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_card, {
          onClick: _cache[2] || (_cache[2] = () => emit('localGamePressed')),
          class: "ml-8 pa-8",
          elevation: "8",
          color: "grey-darken-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Play locally")
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})